import { render, staticRenderFns } from "./TaskCardSection.vue?vue&type=template&id=09791ca5"
import script from "./TaskCardSection.vue?vue&type=script&lang=js"
export * from "./TaskCardSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports